const legacyRoleGroups: Record<string, string[]> = {
  Administrator: ['Admin', 'SuperAdmin', 'QCDocAdmin'],
  'Global Quality Lead': ['GQL'],
  'Category Manager': ['CM'],
  'QA Lab': ['QALab'],
  'QA Lab Supervisor': ['QALabSupervisor', 'QALab'],
  'QA View': ['ReadOnly'],
  'Purchasing Agent': ['PurchasingAgent'],
  Manager: ['Manager'],
  'Project Manager': ['Manager'],
  'Group Leader': ['GroupLeader'],
  Logistics: ['Logistics'],
  'Supply Chain': ['SupplyChain'],
  Regulatory: ['Regulatory'],
  'Formula Editor': ['FormulaEditor'],
  Hdfx: ['Hdfx'],
  'Quality Documenter': ['QATech', 'COAAdmin', 'ReportViewer'],
  PSD: ['ProductOwner'],
  Assistant: ['ReadOnly'],
  'Packaging Admin': ['PackagingAdmin'],
};

export function compatibilityGroupsFor(role: string): string[] {
  return legacyRoleGroups[role] ?? [];
}

export function expandAssignedRoles(roles: unknown): string[] {
  const names = Array.isArray(roles) ? roles.filter((name): name is string => typeof name === 'string') : [];
  return [...new Set(names.flatMap((name) => {
    const scoped = name.match(/^(.+?)\s+\[([^\]]+)\]$/);
    const base = scoped?.[1] ?? name.replace(/\s+-\s+.+$/, '');
    const compatibility = compatibilityGroupsFor(base);
    return scoped ? [name, `${base} - ${scoped[2]}`, base, ...compatibility, ...compatibility.map((group) => `${group} - ${scoped[2]}`)]
      : [name, base, ...compatibility];
  }))];
}